import React from 'react';
import { Icon } from './Icon.js';
export const IconRanking = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M9 16H3V21H9", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M15 14H21V21H15", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M9 10H15V21H9V10Z", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M12 6V1H11.5L10 2", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconRanking.js.map